import { render } from "./BootstrapCheckbox.vue?vue&type=template&id=7f49fcfc"
import script from "./BootstrapCheckbox.vue?vue&type=script&lang=js"
export * from "./BootstrapCheckbox.vue?vue&type=script&lang=js"

import "./BootstrapCheckbox.vue?vue&type=style&index=0&id=7f49fcfc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__